import { useState, useEffect, useCallback } from "react";
import { ChevronUp } from "lucide-react";

/**
 * BackToTop — floating "scroll to top" button.
 * Appears when user scrolls down > 400px.
 * Positioned fixed bottom-right.
 */
export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setVisible(window.scrollY > 400);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (!visible) return null;

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={scrollToTop}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") scrollToTop();
      }}
      className="fixed bottom-6 right-6 z-[900] w-11 h-11 rounded-full bg-zap-navy/80 hover:bg-zap-navy text-white shadow-lg flex items-center justify-center cursor-pointer transition-all hover:scale-110 backdrop-blur-sm"
      title="גלול למעלה"
      style={{ animation: "fadeInUp 0.3s ease-out" }}
    >
      <ChevronUp className="w-5 h-5" />
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </span>
  );
}
